import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Typography as UITypography } from '@peritasai/ui-components';
import { periverseTheme, themeShape } from '@peritasai/ui-shared';
import React from 'react';
import RemoveCartIcon from '../../../../assets/svg/remove-cart.svg';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: themeShape.borderRadius.extraLarge,
    maxWidth: '644px',
    width: '100%',
  },
}));
const InstructionImageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  padding: theme.spacing(1.5, 0),
  position: 'relative',
  overflow: 'hidden',
}));

const InstructionText = styled(UITypography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  //   padding: theme.spacing(0, 2),
}));

export interface CartRemovalDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const CartRemovalDialog: React.FC<CartRemovalDialogProps> = ({
  open,
  onConfirm,
  onCancel,
}) => {
  const handleClose = () => {
    onCancel();
  };

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: '#E5E5E5',
            opacity: 1,
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 3,
          borderBottom: '1px solid rgba(0,0,0,0.12)',
        }}
      >
        <Typography variant="h6" component="span" sx={{ fontWeight: 700 }}>
          Cart Removed from Detection Zone?
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: 3 }}>
        <InstructionImageContainer>
          <img
            src={RemoveCartIcon}
            alt={'Move Tray'}
            height="238px"
            width="468px"
            style={{ display: 'block' }}
          />
        </InstructionImageContainer>
        <InstructionText variant="body1" sx={{ fontWeight: 700 }}>
          To avoid the Cart being automatically re-counted, first remove them
          from the Picking Station Detection Zone and then select Cart Removed.
        </InstructionText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="outlined"
          sx={{ textTransform: 'none' }}
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{
            textTransform: 'none',
            backgroundColor: periverseTheme.palette.primary.main,
            '&:hover': {
              backgroundColor: periverseTheme.palette.primary.dark,
            },
          }}
          onClick={onConfirm}
        >
          Cart Removed
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};
